import React from "react";
import HomeJumbotron from "./HomeJumbotron";
import FeatureContentLeft from "./FeatureContentLeft";
import FeatureContentRight from "./FeatureContentRight";
import HomeCallToAction from "./HomeCallToAction";
import PublicBlueprint from "components/blueprints/PublicLayerBlueprint";

function HomePage() {
  return (
    <div className="container mx-auto">
      <HomeJumbotron />
      <FeatureContentLeft />
      <FeatureContentRight />
      <FeatureContentLeft />
      <HomeCallToAction />
    </div>
  );
}

export default PublicBlueprint(HomePage);
